<template>
  <BaseModal
    :is-visible="isVisible"
    @hideModal="hideModal()"
    :is-editable="false"
    :is-archivable="false"
    size="xl"
  >
    <template #header></template>
    <template #body>
      <Loader v-if="isLoading"></Loader>
      <object v-if="display && !isLoading" style="height: 80vh; width: 100%" :data="base64data"></object>
      <div class="btn-group">
        <button v-if="canBeAccepted && getSignBySMS" type="button" class="btn btn-success" @click="showAgreementAcceptModal()" > {{ $t('buttons.acceptAndSign') }} </button>
        <button v-else-if="canBeAccepted && !getSignBySMS" type="button" class="btn btn-success" @click="showAgreementAcceptModal()" > {{ $t('buttons.acceptOffer') }} </button>
        <button v-if="canBeRejected" type="button" class="btn btn-danger" @click="hideModal()" > {{ $t('buttons.rejectOffer') }} </button>
        <button type="button" class="btn btn-success" v-if="false" > {{ $t('buttons.acceptWithCommentOffer') }} </button>
        <button type="button" class="btn btn-warning" @click="downloadPDF()"> {{ $t('buttons.downloadPDF') }} </button>
        <button type="button" class="btn btn-default" @click="hideModal()"> {{ $t('buttons.cancel') }} </button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader'

export default {
  name: 'AgreementPreviewHTMLModal',
  components: {
    BaseModal,
    Loader
  },
  props: ['agreementList'],
  computed: {
    canBeAccepted () {
      // return this.getAgreementById(this.getAgreementId).decisionUser === 1
      // eslint-disable-next-line eqeqeq
      return this.getAgreementById(this.getAgreementId).status == 1
    },
    canBeRejected () {
      // return (this.getAgreementById(this.getAgreementId).decisionUser === 1 ||
      //   this.getAgreementById(this.getAgreementId).decisionUser === 4)
      // eslint-disable-next-line eqeqeq
      return this.getAgreementById(this.getAgreementId).status == 1
    },
    ...mapGetters({
      isVisible: 'agreements/previewModal/getIsAgreementPreviewHTMLModalVisible',
      getAgreementId: 'agreements/previewModal/getAgreementId',
      isLoading: 'agreements/previewModal/getIsLoading',
      base64data: 'agreements/previewModal/getBase64data',
      display: 'agreements/previewModal/getIsFetchSuccessful',
      getSignBySMS: 'agreements/acceptModal/getSignBySMS'
    })
  },
  watch: {
  },
  methods: {
    getAgreementById (id) {
      if (this.agreementList && id) {
        return this.agreementList.find(agreement => agreement['@id'] === id)
      } else {
        return false
      }
    },
    showAgreementAcceptModal () {
      this.toggleAgreementAcceptModal()
      this.setAgreementId(this.getAgreementId)
      this.fetchAgreement()
    },
    hideModal () {
      this.toggleAgreementPreviewHTMLModal()
      this.reset()
    },
    ...mapMutations({
      toggleAgreementPreviewHTMLModal: 'agreements/previewModal/toggleAgreementPreviewHTMLModal',
      reset: 'agreements/previewModal/reset',
      toggleAgreementAcceptModal: 'agreements/acceptModal/toggleAgreementAcceptModal',
      setAgreementId: 'agreements/acceptModal/setAgreementId'
    }),
    ...mapActions({
      downloadPDF: 'agreements/previewModal/downloadPdf',
      fetchAgreement: 'agreements/acceptModal/fetchAgreement'
    })
  }
}
</script>
